/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../images/laundry-care-logo.png';
import {
  ArrowLeftEndOnRectangleIcon,
  DocumentIcon,
  InformationCircleIcon,
  PaperAirplaneIcon,
  UserIcon,
  UsersIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const { user, applicantStatus } = useAuth();
  const location = useLocation();
  const { pathname } = location;
  const { logout } = useAuth();
  const navigate = useNavigate();
  const trigger = useRef(null);
  const sidebar = useRef(null);

  // const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  // const [sidebarExpanded, setSidebarExpanded] = useState(
  //   storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  // );

  // close if the esc key is pressed
  // useEffect(() => {
  //   const keyHandler = ({ keyCode }) => {
  //     if (!sidebarOpen || keyCode !== 27) return;
  //     setSidebarOpen(false);
  //   };
  //   document.addEventListener('keydown', keyHandler);
  //   return () => document.removeEventListener('keydown', keyHandler);
  // });

  // useEffect(() => {
  //   localStorage.setItem('sidebar-expanded', sidebarExpanded);
  //   if (sidebarExpanded) {
  //     document.querySelector('body').classList.add('sidebar-expanded');
  //   } else {
  //     document.querySelector('body').classList.remove('sidebar-expanded');
  //   }
  // }, [sidebarExpanded]);

  const handleLogout = () => {
    logout(); // clear token & reset context
    navigate('/signin'); // redirect to login page
  };

  return (
    <div>
      <div
        className={`fixed inset-0 bg-white bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
          sidebarOpen
            ? 'opacity-500 bg-slate-600'
            : 'opacity-0 pointer-events-none'
        }`}
        aria-hidden="true"></div>

      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64  2xl:!w-64 shrink-0 bg-portal-100 px-4 py-2 transition-all duration-200 ease-in-out rounded-r-3xl sm:rounded-none ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-64'
        }`}>
        <div className="flex justify-between my-1 pr-3 sm:px-2">
          <NavLink end to="/" className="2xl:hidden block mt-2">
            <img src={logo} alt="laundry care icon" className="w-full " />
          </NavLink>
          <NavLink end to="/" className="hidden 2xl:block mt-2 2xl:mb-2">
            <img src={logo} alt="laundry care icon" className="  w-auto" />
          </NavLink>
          <button
            ref={trigger}
            className="lg:hidden text-slate-500 hover:text-slate-400 ml-4"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}>
            <span className="sr-only">Close sidebar</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Links */}
        <div className="space-y-8">
          {/* Pages group */}
          <div>
            <ul className="mt-4">
              <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('my-application') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/my-application"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('my-application') &&
                    'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <DocumentIcon className="h-6 w-6" />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      My Application
                    </span>
                  </div>
                </NavLink>
              </li>
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('available-jobs') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/available-jobs"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('available-jobs') &&
                    'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={job_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Available Jobs
                    </span>
                  </div>
                </NavLink>
              </li> */}
              <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('my-profile') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/profile"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('my-profile') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <UserIcon className="h-6 w-6" />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      My Profile
                    </span>
                  </div>
                </NavLink>
              </li>
              {/* {applicantStatus === 'interview' && (
                <li
                  className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                    pathname.includes('interview-media-upload') && 'bg-sky-50'
                  }`}>
                  <NavLink
                    end
                    to="/interview-media-upload"
                    onClick={() => setSidebarOpen(false)}
                    className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                      pathname.includes('interview-media-upload') &&
                      'hover:text-slate-800'
                    }`}>
                    <div className="flex items-center">
                      <VideoCameraIcon className="h-6 w-6" />
                      <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                        Upload Images/Videos
                      </span>
                    </div>
                  </NavLink>
                </li>
              )} */}
              {!user?.applied && (
                <li
                  className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                    pathname.includes('apply') && 'bg-sky-50'
                  }`}>
                  <NavLink
                    end
                    to="/apply"
                    onClick={() => setSidebarOpen(false)}
                    className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                      pathname.includes('apply') && 'hover:text-slate-800'
                    }`}>
                    <div className="flex items-center">
                      <PaperAirplaneIcon className="h-6 w-6" />
                      <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                        Apply
                      </span>
                    </div>
                  </NavLink>
                </li>
              )}
              <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('help') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/help"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('help') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <InformationCircleIcon className="h-6 w-6" />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Help
                    </span>
                  </div>
                </NavLink>
              </li>
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('agreement') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/agreement"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('agreement') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={about_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Agreement
                    </span>
                  </div>
                </NavLink>
              </li> */}
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('thankyou1') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/thankyou1"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('thankyou1') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={about_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Thank You 1
                    </span>
                  </div>
                </NavLink>
              </li> */}
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('thankyou2') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/thankyou2"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('thankyou2') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={about_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Thank You 2
                    </span>
                  </div>
                </NavLink>
              </li> */}
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('onboarding') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/onboarding"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('onboarding') && 'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={about_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Onboarding
                    </span>
                  </div>
                </NavLink>
              </li> */}
              {/* <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('onboarding-complete') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/onboarding-complete"
                  onClick={() => setSidebarOpen(false)}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('onboarding-complete') &&
                    'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <img src={about_icon} />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Onboarding Complete
                    </span>
                  </div>
                </NavLink>
              </li> */}
              <li
                className={`px-1 md:px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
                  pathname.includes('onboarding-complete') && 'bg-sky-50'
                }`}>
                <NavLink
                  end
                  to="/"
                  onClick={() => handleLogout()}
                  className={`block text-slate-900 hover:font-semibold truncate transition duration-150 ${
                    pathname.includes('onboarding-complete') &&
                    'hover:text-slate-800'
                  }`}>
                  <div className="flex items-center">
                    <ArrowLeftEndOnRectangleIcon className="h-6 w-6" />
                    <span className="text-md font-medium ml-3 hover:font-semibold 2xl:opacity-100 duration-200">
                      Logout
                    </span>
                  </div>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
